import { render, staticRenderFns } from "./HorisontalTabsList.vue?vue&type=template&id=50db4936&scoped=true&"
import script from "./HorisontalTabsList.vue?vue&type=script&lang=js&"
export * from "./HorisontalTabsList.vue?vue&type=script&lang=js&"
import style0 from "./HorisontalTabsList.vue?vue&type=style&index=0&id=50db4936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db4936",
  null
  
)

export default component.exports